import PropType from 'prop-types';
import React from 'react';

export const InputText = React.forwardRef((props, ref) => {
  const inputProps = { ...props };
  const {
    type,
    isMobile,
    isLoading,
    additionalClassName,
    additionalStyle,
    messageMode,
    msgText,
    additionalMessageClassName,
    additionalMessageStyle,
    id,
    disabled,
    label,
    secondaryLabel,
    leftView,
    rightView,
    additionalLeftViewClassName,
    additionalLeftViewStyle,
    additionalRightViewClassName,
    additionalRightViewStyle,
  } = props;

  /** Copy the props and removed unwanted props for <input> */
  delete inputProps.isMobile;
  delete inputProps.isLoading;
  delete inputProps.messageMode;
  delete inputProps.additionalClassName;
  delete inputProps.additionalStyle;
  delete inputProps.msgText;
  delete inputProps.additionalMessageClassName;
  delete inputProps.additionalMessageStyle;
  delete inputProps.secondaryLabel;
  delete inputProps.rightView;
  delete inputProps.leftView;
  delete inputProps.additionalRightViewClassName;
  delete inputProps.additionalRightViewStyle;
  delete inputProps.additionalLeftViewClassName;
  delete inputProps.additionalLeftViewStyle;

  const classes = ['input-text-parent-container'];
  const rightViewClasses = ['right-view'];
  const leftViewClasses = ['left-view'];

  if (isMobile) {
    classes.push('input-text-mobile-container');
  } else {
    classes.push('input-text-container');
  }

  /** Add additional Classes provided as prop to container */
  if (additionalClassName && additionalClassName?.length > 0) {
    classes.push(...additionalClassName);
  }

  /** Add additional Classes provided as prop to left view */
  if (additionalLeftViewClassName && additionalLeftViewClassName?.length > 0) {
    leftViewClasses.push(...additionalLeftViewClassName);
  }

  /** Add additional Classes provided as prop to right view */
  if (additionalRightViewClassName && additionalRightViewClassName?.length > 0) {
    rightViewClasses.push(...additionalRightViewClassName);
  }

  /** Show loading indicator in input */
  if (isLoading) {
    classes.push('loading');
  }

  if (messageMode) {
    classes.push(messageMode);
  }

  const autoComplete = type === 'password' ? 'new-password' : 'off';

  return (
    <div style={{ ...(additionalStyle || undefined) }} className={classes.join(' ')}>
      <label id={`${id} Label`} htmlFor={id} className={disabled ? 'label-disabled' : ''}>
        {/** render label and secondaryLabel */}
        {label}
        {secondaryLabel && <span className="secondaryLabel">{secondaryLabel}</span>}
      </label>
      <div style={{ position: 'relative' }}>
        {leftView && (
          /** render left view */
          <div className={leftViewClasses.join(' ')} style={{ ...(additionalLeftViewStyle || undefined) }}>
            {leftView}
          </div>
        )}
        <input ref={ref} {...inputProps} autoComplete={autoComplete} />
        {/** render loading indicator */}
        {isLoading && !rightView && <i className="txtbox-spinner" />}
        {/** render custom right view */}
        {!isLoading && rightView && (
          <div className={rightViewClasses.join(' ')} style={{ ...(additionalRightViewStyle || undefined) }}>
            {rightView}
          </div>
        )}
        {/** render text below input in different styling based on messageMode value */}
        {messageMode ? (
          <span
            style={{ ...(additionalMessageStyle || undefined) }}
            className={
              additionalMessageClassName && additionalMessageClassName.length
                ? additionalMessageClassName.join(' ')
                : undefined
            }>
            {msgText}
          </span>
        ) : null}
      </div>
    </div>
  );
});
InputText.displayName = 'InputText';

InputText.propTypes = {
  type: PropType.oneOf(['text', 'number', 'tel', 'email', 'password']),
  isMobile: PropType.bool,
  isLoading: PropType.bool,
  additionalClassName: PropType.arrayOf(PropType.string),
  additionalStyle: PropType.object,
  messageMode: PropType.oneOf(['error', 'information', 'success', 'warning']),
  msgText: PropType.string,
  additionalMessageClassName: PropType.arrayOf(PropType.string),
  additionalMessageStyle: PropType.object,
  id: PropType.string,
  disabled: PropType.bool,
  label: PropType.string,
  secondaryLabel: PropType.string,
  leftView: PropType.any,
  rightView: PropType.any,
  additionalLeftViewClassName: PropType.arrayOf(PropType.string),
  additionalLeftViewStyle: PropType.object,
  additionalRightViewClassName: PropType.arrayOf(PropType.string),
  additionalRightViewStyle: PropType.object,
};
